/**
 * Formate un prix stocké en centimes vers un affichage en euros
 * @param priceInCents - Prix en centimes (ex: 59900)
 * @param currency - Devise (par défaut: 'EUR')
 * @returns Prix formaté (ex: '599,00 €')
 *
 * NOTE: Ce fichier est maintenant un wrapper pour le service centralisé
 * Utilisez @/services/pricingService pour les nouveaux fichiers
 */
import { formatPrice as formatPriceService } from '@/services/pricingService';

export function formatPriceFromCents(priceInCents: number, currency: string = 'EUR'): string {
  return formatPriceService(priceInCents, currency);
}
